<template>
    <div class="banner-image-area position-relative">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6 order-1 order-lg-1 wow move-up">
                    <div class="banner-image__media">
                        <img src="../assets/img/trustami/mentor.svg" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-6 order-2 order-lg-2 wow move-up">
                    <div class="banner-image__content">
                        <div class="section-title-wrapper mb-20">
                            <h2 class="section-title font-weight--light">{{ $t("home.support") }}</h2>
                        </div>
                        <div class="banner-image__text section-space--mb_40">
                            <ul class="check-list green-check-list mb-30">
                                <li class="list-item">{{ $t("home.support_1") }}</li>
                                <li class="list-item">{{ $t("home.support_2") }}</li>
                                <li class="list-item">{{ $t("home.support_3") }}</li>
                                <li class="list-item">{{ $t("home.support_4") }}</li>
                                <li class="list-item">{{ $t("home.support_5") }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'BannerHome',
    };
</script>
